import * as styles from './styles'

/**
 * How many values one row stands for, beside its name.
 *
 * It is a picture of what the row already says another way — the tokens under
 * a category, the part-chosen box on a parent — so it is left out of the
 * accessible name rather than read out after every one of them.
 */
export const FilterCount: React.FC<{ count: number }> = ({ count }) =>
  count === 0 ? null : (
    <span aria-hidden={true} className={styles.selectors.count}>
      <span className={styles.selectors.text}>{count}</span>
    </span>
  )
FilterCount.displayName = 'Calendar: FilterCount'
